import { SITE } from '@newsmedia/shared';

const LOGO = '/media/2020/12/b0a06efe-news-logo.png';
// 沿用舊站 WordPress 網站圖示（favicon）— 正方形，收折時也能完整顯示。
const FAVICON = '/media/2020/12/fbc11df5-cropped-b0a06efe-news-logo-192x192.png';

/**
 * 側欄品牌區。logo 為白色字，放在比側欄稍深的橫幅上自然浮現。
 * 展開：favicon + 橫式 wordmark；收折：只顯示 favicon（置中）。
 */
export default function SiderBrand({ collapsed }: { collapsed: boolean }) {
  return (
    <div
      className={`flex h-16 items-center overflow-hidden border-b border-white/10 bg-[#1a212b] ${
        collapsed ? 'justify-center px-2' : 'gap-2.5 px-4'
      }`}
    >
      <img
        src={FAVICON}
        alt={SITE.name}
        className="h-8 w-8 shrink-0 rounded-md ring-1 ring-white/15"
      />
      {!collapsed && <img src={LOGO} alt={SITE.name} className="h-7 w-auto max-w-[130px] object-contain" />}
    </div>
  );
}
